/**
 * @generated SignedSource<<553880d0b4232d52257bf97851bcc28d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AnalyticsValueUnit = "duration" | "percentage" | "unit";
import { FragmentRefs } from "relay-runtime";
export type WorkspaceRoutineAnalyticsChartAndTable_query$data = {
  readonly workspace: {
    readonly analytics: {
      readonly connection: {
        readonly " $fragmentSpreads": FragmentRefs<"TimeSeriesChartAndTable_data">;
      };
      readonly valueUnit: AnalyticsValueUnit;
    } | null;
  };
  readonly " $fragmentType": "WorkspaceRoutineAnalyticsChartAndTable_query";
};
export type WorkspaceRoutineAnalyticsChartAndTable_query$key = {
  readonly " $data"?: WorkspaceRoutineAnalyticsChartAndTable_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutineAnalyticsChartAndTable_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "groupByDimension"
    },
    {
      "kind": "RootArgument",
      "name": "metric"
    },
    {
      "kind": "RootArgument",
      "name": "routineId"
    },
    {
      "kind": "RootArgument",
      "name": "timeResolution"
    },
    {
      "kind": "RootArgument",
      "name": "workspaceId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceRoutineAnalyticsChartAndTable_query",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "workspaceId"
        }
      ],
      "concreteType": "Workspace",
      "kind": "LinkedField",
      "name": "workspace",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "routineId",
                  "variableName": "routineId"
                }
              ],
              "kind": "ObjectValue",
              "name": "filter"
            },
            {
              "kind": "Variable",
              "name": "metric",
              "variableName": "metric"
            }
          ],
          "concreteType": "WorkspaceTimeSeriesAnalytics",
          "kind": "LinkedField",
          "name": "analytics",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "valueUnit",
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "groupByDimension",
                  "variableName": "groupByDimension"
                },
                {
                  "kind": "Variable",
                  "name": "timeResolution",
                  "variableName": "timeResolution"
                }
              ],
              "concreteType": "TimeSeriesAnalyticsConnection",
              "kind": "LinkedField",
              "name": "connection",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "TimeSeriesChartAndTable_data"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "3911c1ea872e3efc7ebfebf9cfa364c7";

export default node;
